<template>
  <div>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src="item.FILE_URL" class="image" style="height:200px" v-if="item.FILE_TYPE === 1">
          <img :src="pdfImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
            v-else-if="item.FILE_TYPE === 2">
          <img :src="wordImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
            v-else-if="item.FILE_TYPE === 3">
          <img :src="unknowImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <el-button size="medium" type="text" class="button" @click="openImage(item.FILE_URL)" v-if="item.FILE_TYPE === 1">查看大图</el-button>
              <el-button size="medium" type="text" class="button" @click="downLoad(item.FILE_URL)" v-else>下载</el-button>
              <el-button size="medium" type="text" class="button" @click="previewFile(item.FILE_URL)" v-if="item.FILE_TYPE === 2">预览</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-dialog :visible.sync="pdfPreviewDialog" title="资质凭证" width="50%" center>
      <pdf :src="src" v-for="i in numPages" :key="i" :page="i" style="width:100%" ref="pdf"></pdf>
    </el-dialog>
  </div>
</template>
<script>
import { queryContractFun } from 'api/systemSetting';
import pdf from 'vue-pdf';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      tableData: [],
      fileList: [],
      url: '',
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('@/assets/images/pdf.png'),
      wordImage: require('@/assets/images/word.png'),
      unknowImage: require('@/assets/images/unknow.png'),
      pdfUrl: '',
      src: '',
      numPages: null, // pdf 总页数
      pdfPreviewDialog: false,
    };
  },
  methods: {
    queryContract() {
      const data = {
        QUALIFY_ID: sessionStorage.getItem('qualifyId'),
      };
      queryContractFun(data)
        .then((result) => {
          if (result) {
            this.tableData = result;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = e;
    },
    downLoad(e) {
      window.location.href = e;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    previewFile(file) {
      this.pdfUrl = file;
      // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
      this.src = pdf.createLoadingTask(this.pdfUrl);
      this.getNumPages();
      this.pdfPreviewDialog = true;
    },
    //  计算pdf页码总数
    getNumPages() {
      const loadingTask = this.src;
      loadingTask.promise.then((Pdf) => {
        this.numPages = Pdf.numPages;
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('pdf 加载失败', err);
      });
    },
  },
  created() {
    this.queryContract();
  },
};
</script>
<style>
.image {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/foodSecurity/contractImage.vue